import { render, staticRenderFns } from "./LoadingSimple.vue?vue&type=template&id=dc5b788e"
import script from "./LoadingSimple.vue?vue&type=script&lang=js"
export * from "./LoadingSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports